import { useTranslation } from 'react-i18next';

import type { QriotsErrorKind } from '@/services/qriotsErrors';

interface QriotsErrorStateProps {
  kind: QriotsErrorKind;
  retryAfterSec?: number;
  onRetry?: () => void;
  onEditId?: () => void;
}

export function QriotsErrorState({
  kind,
  retryAfterSec,
  onRetry,
  onEditId,
}: QriotsErrorStateProps) {
  const { t } = useTranslation('riot');

  const message =
    kind === 'not_found'
      ? t('error.notFound')
      : kind === 'rate_limited'
        ? t('error.rateLimited', { seconds: retryAfterSec ?? 5 })
        : kind === 'auth'
          ? t('error.auth')
          : kind === 'network'
            ? t('error.network')
            : kind === 'server'
              ? t('error.server')
              : t('error.unknown');

  return (
    <div className="mx-4 flex flex-col items-center gap-3 rounded-xl bg-bg-secondary p-6 text-center">
      <p className="text-sm text-fg">{message}</p>
      <div className="flex gap-2">
        {kind === 'not_found' && onEditId && (
          <button
            type="button"
            onClick={onEditId}
            className="rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-brand-fg transition-opacity active:opacity-80"
          >
            {t('cta.editId')}
          </button>
        )}
        {kind !== 'not_found' && kind !== 'auth' && onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-brand-fg transition-opacity active:opacity-80"
          >
            {t('cta.retry')}
          </button>
        )}
      </div>
    </div>
  );
}
